import React from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { getIn } from "formik";

export function InputDate({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, handleBlur, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  type = "text",
  size = "small",
  variant = "outlined",
  options,
  isLoading,
  minDate,
  maxDate,
  shouldDisableDate,
  ...props
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...field}
        {...props}
        id={field.name}
        name={field.name}
        label={label}
        value={field.value}
        loading={isLoading}
        onBlur={handleBlur}
        minDate={minDate}
        maxDate={maxDate}
        shouldDisableDate={shouldDisableDate}
        renderInput={(params) => (
          <TextField
            {...field}
            {...props}
            {...params}
            size={size}
            type={type}
            name={field.name}
            label={label}
            variant={variant}
            onBlur={handleBlur}
            helperText={getIn(touched, field.name) && getIn(errors, field.name)}
            error={Boolean(
              getIn(touched, field.name) && getIn(errors, field.name)
            )}
          />
        )}
        onChange={(newValue) => {
          setFieldValue(field.name, newValue);
        }}
      />
    </LocalizationProvider>
  );
}
